import { handleActions } from 'redux-actions';

import { CheckoutStoreSlice } from './types';
import fnCalculateTotalCartCost from './fnCalculateTotalCartCost';

export const oInitialState: CheckoutStoreSlice = {
  checkoutTotal: 0,
  fullName: '',
  firstName: '',
  lastName: '',
  email: '',
  addressDetails: {
    block: '',
    city: '',
    stateAbbrv: '',
    zip: '',
    countryAbbrv: '',
  },
  userLookupId: '',
  dadTransactionId: '',
  sEncodedEmail: '',
  aCart: [],
  matchingGift: null,
  _lastUpdated: null,
};

const reducer = handleActions<CheckoutStoreSlice, any>(
  {
    'Checkout/UPDATE': (state, action) => ({
      ...state,
      ...action.payload,
      _lastUpdated: Date.now(),
    }),
    'Checkout/RESET': () => oInitialState,
    'Checkout/CART/ADD_ITEM': (state, action) => {
      const aCartWithNewItem = [...state.aCart, action.payload];
      const nUpdatedTotalCost = fnCalculateTotalCartCost(aCartWithNewItem);
      return {
        ...state,
        checkoutTotal: nUpdatedTotalCost,
        aCart: aCartWithNewItem,
      };
    },
    'Checkout/CART/ADD_ITEMS': (state, action) => {
      const aCartWithNewItems = [...state.aCart, ...action.payload];
      const nUpdatedTotalCost = fnCalculateTotalCartCost(aCartWithNewItems);
      return {
        ...state,
        checkoutTotal: nUpdatedTotalCost,
        aCart: aCartWithNewItems,
      };
    },
    'Checkout/CART/UPDATE_ITEM': (state, action) => {
      const oItemToUpdate = action.payload;
      const aCartWithUpdatedItem = state.aCart.map((oItem) => {
        if (oItem.sId === oItemToUpdate.sId) {
          return oItemToUpdate;
        }
        return oItem;
      });
      const nUpdatedTotalCost = fnCalculateTotalCartCost(aCartWithUpdatedItem);
      return {
        ...state,
        checkoutTotal: nUpdatedTotalCost,
        aCart: aCartWithUpdatedItem,
      };
    },
    'Checkout/CART/REMOVE_ITEM': (state, action) => {
      const sIdToRemove = action.payload;
      const aCartWithoutItem = state.aCart.filter(
        (oItem) => oItem.sId !== sIdToRemove
      );
      const nUpdatedTotalCost = fnCalculateTotalCartCost(aCartWithoutItem);
      return {
        ...state,
        checkoutTotal: nUpdatedTotalCost,
        aCart: aCartWithoutItem,
      };
    },
    'Checkout/CART/CLEAR': (state) => ({
      ...state,
      checkoutTotal: 0,
      aCart: [],
    }),
  },
  oInitialState,
  { prefix: 'Checkout' }
);

export default reducer;
